import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Сверка GTIN',
      title: 'Сверка GTIN',
      executeAction: 'Отправить',
      errorMessage: 'Ошибка',
      successMessage: 'Запрос успешно отправлен',
      fields: {
        docType: 'Тип документа',
        file: 'Файл',
        email: 'Email',
        emails: 'Адреса'
      },
    }
  }
}